export default __webpack_public_path__ + "media/images/logo-1b1d811681c026c744f845923a6b300e.svg";